import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-google-map',
  standalone: true,
  imports: [],
  templateUrl: './google-map.component.html',
  styleUrl: './google-map.component.scss'
})
export class GoogleMapComponent {

  googleMapsUrl: SafeResourceUrl;


  constructor(private sanitizer: DomSanitizer) {
    // Sanitiza la URL para que sea segura
    this.googleMapsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'urls'
    );
  }

}
